module.exports = __webpack_public_path__ + "static/media/kinderbetreuung.d5964378.jpg";